/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { PolicyParams } from '@/interfaces/policy';
import { createModel } from 'ice';

export default createModel({
  state: {
    policyUrl: '',
    termsUrl: '',
  } as PolicyParams,
  reducers: {
    updateCurrentPolicy(prevState: PolicyParams, payload) {
      prevState.policyUrl = payload.policyUrl;
      prevState.termsUrl = payload.termsUrl;
    },
  },
});
